import { render, staticRenderFns } from "./FranchiseeMatchesCard.vue?vue&type=template&id=52062fcb&scoped=true&"
import script from "./FranchiseeMatchesCard.vue?vue&type=script&lang=js&"
export * from "./FranchiseeMatchesCard.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseeMatchesCard.vue?vue&type=style&index=0&id=52062fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52062fcb",
  null
  
)

export default component.exports